// extracted by mini-css-extract-plugin
export default {"box":"MusicVideoBox_box__pb1ng","play":"MusicVideoBox_play__jFhu6","badge":"MusicVideoBox_badge__g6rg6","dur":"MusicVideoBox_dur__xUkHH","warn":"MusicVideoBox_warn__arTU5"};